import { Grid, Typography, Container, Box, styled, Paper, Avatar } from "@mui/material";
import React, { useEffect } from "react";
import globals from '../globals';
import CourseCarousel from '../components/carousels/courseCarousel'
import WhoWeAre from "../components/about_us_blocks/who_we_are";
import WhyChooseUs from "../components/about_us_blocks/why_choose_us";
import { fontSize } from "@mui/system";

const AboutUsPage = () => {

    const [suggestedCourses, setSuggestedCourses] = React.useState([])
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: globals.colors.lightGray,
        ...theme.typography.body2,
        padding: theme.spacing(3),
        textAlign: 'center',
        color: globals.colors.textColor,
        ...theme.applyStyles('light', {
            backgroundColor: 'white',
        }),
    }));

    useEffect(() => {
        fetch(globals.apiUrl + '/courses/suggested', {
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                setSuggestedCourses(data);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }, []);

    return (
        <Container>
            <Grid container sx={{ justifyContent: 'center', textAlign: 'center' }}>
                <Grid item>
                    <img
                        src="logo_eAcademiaBg.webp"
                        alt='Лого на eAcademiaBg - изчистено'
                        title='eAcademiaBg Бухльо'
                        style={{ marginTop: 10 }} />
                    <Typography variant='h1' sx={{ mt: 2, color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold' }}><strong>Кои сме ние?</strong></Typography>
                    <Typography sx={{ mt: 2, color: globals.colors.gray, fontSize: 20, fontWeight: 'bold' }}>eAcademiaBg е проект, създаден от млади амбициозни хора,
                        вдъхновени от идеята за модерно и достъпно образование.
                        С подкрепата на опитни професионалисти, ние предлагаме иновативни онлайн уроци, съобразени с нуждите на всеки обучаващ се.</Typography>
                </Grid>

                <WhoWeAre />
                <WhyChooseUs />

                {/* Team testimonials */}
                <Grid container justifyContent={'space-evenly'} textAlign={'center'} spacing={10} sx={{ mt: 5 }}>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='h2' sx={{ mb: 3, fontSize: 35, color: globals.colors.lightRed, fontWeight: 'bold' }}><strong>Екипът зад eAcademiaBg</strong></Typography>
                    </Grid>

                    {/* Neli, Eli, Nikoleta */}
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='neli.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="h3" sx={{ mt: 5, fontSize: 17 }}><strong>Нели Тужарова</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontSize: 15, fontWeight: 'bold' }}>Основател</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>Аз се казвам Нели и съм един от основателите на еАкадемия . Завършила съм СУ “ Климент Охридски “ , Магистър по Клетъчна Биология. Причината да създадем онлайн платформата е да дадем възможност за качествено и достъпно обучение от всяка точка на България. Да изградим доверие и знание във всеки, който желае да се учи.</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='elena.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="h3" sx={{ mt: 5, fontSize: 17, fontWeight: 'bold' }}><strong>Елена Димкина</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Учител</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Аз съм Елена и съм от екипа на eAcademiaBg. По професия съм учител.
                                Смятам, че онлайн обучението дава допълнителни възможности за повишаване на уменията и знанията на всички, които желаят да се развиват.
                            </Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='nikoleta.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Николета Димкина</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Студент</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Здравейте! Аз съм Николета, първокурсничка в Софийски университет “Св. Климент Охридски” със
                                специалност счетоводство и финанси. От личен опит знам колко трудно е ученето самостоятелно
                                и колко по-лесно става с добър учител до себе си. Затова вярвам в мисията на еАкадемия, да направим
                                ученето по-достъпно, ефективно и мотивиращо, като помагаме на ученици и студенти да постигат целите
                                си по-бързо и уверено.
                            </Typography>
                        </Item>
                    </Grid>
                </Grid>


                {/* Katq, Marieta, Hristo  */}
                <Grid container justifyContent={'space-evenly'} textAlign={'center'} spacing={10} sx={{ mt: 5 }}>
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 350, maxWidth: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='katq.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Екатерина Александрова</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Маркетинг</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Здравйте, аз съм Екатерина и съм част от маркетинг екипа на еАкадемия.
                                Имам завършена бакалавърска степен със специалност „Комуникации и информиране“ и магистърска степен със специалност „Дигитален маркетинг и уеб дизайн“.
                                <br />
                                <br />
                                Вярвам, че онлайн обучението предлага неограничени възможности за развитие, както в професионален, така и в личен план.
                            </Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 350, maxWidth: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='marieta.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Мариета Атанасова</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Маркетинг</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Здравейте, аз съм Мариета Атанасова и съм част от маркетинг екипа на еАкадемияБг.
                                Завърших висшето си образование за Социолог в Германия. По пътя започнах активно
                                да създавам текстове и съдържания с продажна цел, което много ми се понрави.
                                <br />
                                <br />От две години работя в сферата на дигиталния маркетинг и рекламата, но и активно
                                се занимавам с обучителни процеси и менторски програми на ученици и млади хора.
                                Така попаднах на eAcademiaBg, където имам възможност да правя и двете едновременно.
                                Вярвам, че няма по-висша кауза и, поне за мен, удовлетворение от това да предаваш знания нататък!
                            </Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 350, maxWidth: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='hristo.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Христо Хубенов</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Маркетинг</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Аз съм Христо Хубенов и съм част от маркетинг екипа на еАкадемия.
                                Завършил съм Американския университет в България със специалности Бизнес администрация
                                (с концентрация Маркетинг) и Журналистика. Освен това работя и като младши експерт по
                                дигитален маркетинг в една от водещите агенции в България.
                                <br />
                                <br />
                                Присъединих се към eAcademiaBg,
                                защото вярвам в мисията ѝ да предоставя достъпно и качествено образование на всеки.
                                Маркетингът ми дава възможност да помагам на платформата да достига до повече хора и да
                                развива своите идеи.
                                <br />
                                <br />
                            </Typography>
                        </Item>
                    </Grid>
                </Grid>

                {/* Petya, Nini */}
                <Grid container justifyContent={'space-evenly'} textAlign={'center'} spacing={10} sx={{ mt: 5 }} maxWidth={800}>
                    <Grid item xs={12} sm={6}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 350, maxWidth: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='petya.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Петя Димкина</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Софтуерен инженер</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Здравейте, казвам се Петя и съм много щастлива да съм част от екипа на еАкадемия. Завърших бакалавър със специалност
                                "Компютърни Науки" и подспециалност "Финанси". Като човек, който вече учи само онлайн, осъзнавам нуждата
                                да имаш възможност да получаваш знания където и да се намираш. За мен eAcademiaBg дава възможност за знание без граници.
                            </Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Item elevation={3} sx={{ borderRadius: 3, minHeight: 350, maxWidth: 300 }}>
                            <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                                <Avatar src='nini.webp' sx={{ width: 120, height: 120, position: 'absolute', mt: -6 }}></Avatar>
                            </Grid>
                            <Typography variant="body1" sx={{ mt: 5 }}><strong>Николай Нинов</strong></Typography>
                            <Typography variant="h4" color={globals.colors.lightRed} sx={{ fontWeight: 'bold', fontSize: 15 }}>Софтуерен инженер</Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Здравейте, аз съм Николай и съм софтуерен инженер към екипа на еАкадемия. Имам бакалавър с двойна
                                специалност "Математика" и "Компютърни Науки". Онлайн обучението ми е помогнало в професионален
                                и личен план през голяма част от живота ми и вярвам, че е един от най-добрите формати на обучение.
                            </Typography>
                        </Item>
                    </Grid>
                </Grid>
            </Grid>

            {suggestedCourses.length > 0 &&
                <Grid container textAlign={'center'} justifyContent={'center'}>
                    <Grid item>
                        <Typography variant='h2' sx={{ mt: 10, mb: 5, color: globals.colors.lightRed, fontSize: 30, fontWeight: 'bold' }}><strong>Разгледай курсовете които предлагаме</strong></Typography>
                    </Grid>
                    <Grid item>
                        <CourseCarousel courses={suggestedCourses} />
                    </Grid>
                </Grid>
            }
        </Container >
    )
}

export default AboutUsPage